// start:ng42.barrel
export * from './deposit-policy.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/deposit-policy/index.ts